export default __webpack_public_path__ + "locales/tr/ChangePortalOwner.json?hash=347817d8c49761352ad148ec5bbbfeeb";